import React from 'react';
import Icon from '../../shared/Icon';
import './AlertSteps.css';

/**
 * Step 1 — Type.
 *
 * The alert template sits beside Ingest and Reports, and is pre-selected: this
 * wizard is only ever entered for an alert, so the card states what is being
 * built rather than asking a question with one answer. The other templates stay
 * on the generic builder's own type step.
 */
const AlertStepType = ({ formData, onSetFormData, onChooseDifferentTemplate }) => {
  const selected = formData.type === 'alerts';

  return (
    <div className="alert-step-content">
      <h3 className="alert-step-title">Choose automation template</h3>

      <div className="automation-types-grid">
        <div
          className={`automation-type-card${selected ? ' selected' : ''}`}
          role="button"
          tabIndex={0}
          onClick={() => onSetFormData({ ...formData, type: 'alerts' })}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onSetFormData({ ...formData, type: 'alerts' });
            }
          }}
        >
          <div className="automation-type-label">Alerts</div>
          <div className="automation-type-description">
            Notify when thresholds or exceptions are met.
          </div>
        </div>
      </div>

      {/* Without this, selecting Alerts in the generic builder is a one-way
          door: this step offers only the Alerts card, so a mis-click could
          only be undone by cancelling and starting over. */}
      {onChooseDifferentTemplate && (
        <button
          type="button"
          className="resui-btn resui-btn--tertiary alert-step-change-template"
          onClick={onChooseDifferentTemplate}
        >
          Choose a different template
        </button>
      )}

      <div className="resui-banner resui-banner--info alert-step-banner">
        <Icon name="info_outline" />
        <span className="resui-banner-text">
          An alert is created inactive. Nothing evaluates or sends until it is
          explicitly activated.
        </span>
      </div>
    </div>
  );
};

export default AlertStepType;
